<template>
  <div id="projectQuery">
		<el-card :class="detailShow? 'hiddencard' : ''">
			<el-form :model="searchForm" ref="searchForm" label-position="top">
				<el-row>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Project Name:" prop="projectName">
							<el-input clearable v-model="searchForm.projectName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Project Code:" prop="projectNumber">
							<el-input clearable v-model="searchForm.projectNumber" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Department:" prop="department">
							<el-select filterable v-model="searchForm.department" clearable placeholder="Please select">
								<el-option v-for="item in deptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Country:" prop="salesRegion">
							<el-select clearable filterable v-model="searchForm.salesRegion" placeholder="Please select">
								<el-option
									v-for="item in salesRegionList"
									:key="item"
									:label="item"
									:value="item"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Project Status:" prop="projectStatus">
							<el-select clearable v-model="searchForm.projectStatus" placeholder="Please select">
								<el-option
									v-for="item in projectStatus"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Project Manager:" prop="projectManager">
							<el-select
								v-model="searchForm.projectManager"
								clearable
								filterable
								remote
								placeholder="Please input"
								:remote-method="value => remoteMethod('projectManagerList', value)"
							>
								<el-option v-for="(item, index) in projectManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Major Project Level:" prop="majorProjectLevel">
							<el-select multiple clearable v-model="searchForm.majorProjectLevel" placeholder="Please select">
								<el-option
									v-for="item in majorProjectLevel"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Risk Level:" prop="riskLevel">
							<el-select clearable v-model="searchForm.riskLevel" placeholder="Please select">
								<el-option
									v-for="item in riskLevel"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Sub Industry:" prop="customerIndustry">
							<el-input clearable v-model="searchForm.customerIndustry" placeholder="Please input" />
							<!-- <el-select clearable v-model="searchForm.customerIndustry" placeholder="Please select">
								<el-option
									v-for="item in customerIndustry"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select> -->
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Major Project Type:" prop="majorProjectType">
							<el-select clearable v-model="searchForm.majorProjectType" placeholder="Please select">
								<el-option
									v-for="item in majorProjectType"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="3S2S:" prop="is3S2S">
							<el-select clearable v-model="searchForm.is3S2S" placeholder="Please select">
								<el-option
                  v-for="item in yesOrNo"
                  :key="item.labelKey"
                  :label="item.labelValue"
                  :value="item.labelKey"
                >
                </el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
						<el-form-item label="Major Project Category:" prop="majorProjectCategoryList">
							<el-select multiple clearable v-model="searchForm.majorProjectCategoryList" placeholder="Please select">
								<el-option
									v-for="item in majorProjectCategory"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
						<el-form-item label="Customer Satisfaction Survey Status:" prop="customerSurveyStatus">
							<el-select clearable v-model="searchForm.customerSurveyStatus" placeholder="Please select">
								<el-option
									v-for="item in MajorProjectSurveyStatus"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch" style="height: 71px">
						<el-form-item label="Customer Satisfaction Survey Completion Date:" prop="customerSurveyCompletionTime">
							<el-date-picker
								v-model="searchForm.customerSurveyCompletionTime"
								type="daterange"
								range-separator="-"
								start-placeholder="Start date"
								end-placeholder="End date"
								clearable
							>
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch">
						<el-form-item label="Market Satisfaction Survey Status:" prop="marketSurveyStatus">
							<el-select clearable v-model="searchForm.marketSurveyStatus" placeholder="Please select">
								<el-option
									v-for="item in MajorProjectSurveyStatus"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12" v-if="showMoreSearch" style="height: 71px">
						<el-form-item label="Market Satisfaction Survey Completion Date:" prop="marketSurveyCompletionTime">
							<el-date-picker
								v-model="searchForm.marketSurveyCompletionTime"
								type="daterange"
								range-separator="-"
								start-placeholder="Start date"
								end-placeholder="End date"
								clearable
							>
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :xl="showMoreSearch ? 24 : 6" :lg="showMoreSearch ? 16: 8" :md="showMoreSearch? 24 : 12" style="padding: 34px 0 0 0px; text-align: right;">
						<el-button type="primary" size="small" @click="changeMoreSearch()">Advanced Filter</el-button>
						<el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
						<el-button size="small" @click="handleReset()">Reset</el-button>
						<el-button size="small" :loading="exportLoading" @click="handleExport()">Export</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
        <el-table-column prop="projectName" label="Project Name" align="left" min-width="160" fixed="left" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<a style="color:blue;" @click="openDetail(scope.row)">{{ scope.row.projectName }}</a>
					</template>
				</el-table-column>
        <el-table-column prop="projectNumber" label="Project Code" align="left" min-width="160" :show-overflow-tooltip="true"></el-table-column>
       	<el-table-column prop="departmentDesc" label="Department" align="center" min-width="155" :show-overflow-tooltip="true"></el-table-column>
       	<el-table-column prop="salesRegion" label="Country" align="center" min-width="155" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="riskLevelDesc" label="Risk Level" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="riskDescList" label="Risk Description" align="center" :show-overflow-tooltip="true" min-width="165">
					<template slot-scope="scope">
						{{ scope.row.riskDescList ? scope.row.riskDescList.join('; ') : '' }}
					</template>
				</el-table-column>
        <el-table-column prop="majorProjectLevelDesc" label="Major Project Level" align="center" min-width="135" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="majorProjectTypeDesc" label="Major Project Type" align="center" min-width="135" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="customerIndustry" label="Sub Industry" align="center" min-width="135" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="projectManagerDesc" label="Project Manager" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="projectStatusDesc" label="Project Status" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="customerSurveyStatus" label="Customer Satisfaction Survey Status" align="center" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="customerSurveyCompletionTime" label="Customer Satisfaction Survey Completion Date" align="center" min-width="200" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{ scope.row.customerSurveyCompletionTime ? moment(scope.row.customerSurveyCompletionTime).format('YYYY-MM-DD') : '' }}
					</template>
				</el-table-column>
        <el-table-column prop="marketSurveyStatus" label="Market Satisfaction Survey Status" align="center" min-width="200" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{ scope.row.majorProjectLevel === 4 ? '/' : scope.row.marketSurveyStatus }}
					</template>
				</el-table-column>
        <el-table-column prop="marketSurveyCompletionTime" label="Market Satisfaction Survey Completion Date" align="center" min-width="200" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{ scope.row.majorProjectLevel === 4 ? '/' : scope.row.marketSurveyCompletionTime ? moment(scope.row.marketSurveyCompletionTime).format('YYYY-MM-DD') : '' }}
					</template>
				</el-table-column>
       	<el-table-column prop="operation" label="Operation" align="center" min-width="100">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" v-has="{ class: 'MajorProjectDelete' }" @click="openDelete(scope.row)">Delete</el-button>
					</template>
				</el-table-column>
      </el-table>
			<div class="pageDiv" v-if="totalCount && totalCount > 0">
				<el-pagination
					small
					layout="total, prev, pager, next, sizes, jumper"
					:page-sizes="[10, 20, 50, 100]"
					:current-page="currentPage"
					:page-size="pageSize"
					:total="totalCount"
					@size-change="changePageSize"
					@current-change="changePage"
				>
				</el-pagination>
			</div>
		</el-card>
		<detail v-if="detailShow" :key="detailId" :id="detailId" :detailStatus="detailStatus" :companyOrRepresentative="companyOrRepresentative" page="projectQuery" @closeDetail="closeDetail" />
		<el-dialog
			title="Delete"
			width="500px"
			:visible.sync="deleteVisible"
			:close-on-click-modal="false"
		>
			<p style="font-size: 15px; color: red; padding: 0 0 12px 0;">Are you sure you want to delete? If you acknowledge deletion, please enter "I acknowledge"</p>
			<el-form :model="deleteForm" ref="deleteForm" label-width="0">
				<el-form-item 
					label="" 
					prop="reason" 
					:rules="[
						{ required: true, message: 'Please input' },
						{ validator: validateReason, trigger: 'blur' }
					]"
				>
					<el-input v-model="deleteForm.reason" placeholder="Please input" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDelete()">Cancel</el-button>
				<el-button type="primary" :loading="deleteLoading" size="small" @click="projectDelete()">Confirm</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import detail from '../projectDetail/index.vue'
	import moment from 'moment'
  export default {
    name: 'majorProject',
		components: {
			detail
		},
    created () {
			this.getSelectInfo()
			this.getDeptList();
			this.getCountry();
			this.getSurveyStatus()
			this.handleSearch()
			this.openDetailFromRoute()
    },
    activated() {
      this.openDetailFromRoute()
    },
    watch: {
    },
    data () {
      return {
				moment,
				majorProjectType: [],
				majorProjectCategory: [],
				majorProjectLevel: [],
				customerIndustry: [],
				projectStatus: [],
				riskLevel: [],
				projectManagerList: [],
				yesOrNo: [
					{ labelKey: true, labelValue: 'Yes' },
					{ labelKey: false, labelValue: 'No' }
				],
        searchForm: {},
				tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 1,
				exportLoading: false,
				detailShow: false,
				detailId: '',
				detailStatus: '',
				companyOrRepresentative: '',
				fromOtherPage: false,
				sourceTab: '',
				showMoreSearch: false,
				MajorProjectSurveyStatus: [],
				deptList: [],
				salesRegionList: [],
				deleteVisible: false,
				deleteLoading: false,
				deleteForm: {},
      }
    },
    methods: {
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'majorProjectType',
					'majorProjectCategory',
					'majorProjectLevel',
					// 'customerIndustry',
					'projectStatus',
					'riskLevel',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key];
							});
						}
					}
				)
			},
			getDeptList() {
				let url =`${this.$store.state.islhurl}dept/getSelectData`;
				let pm = {
					deptCodechain: 'SelectDept',
				}
				this._post(url, pm).then(
					res => {
						this.deptList = res.data;
					}
				)
			},
			getCountry() {
				let url =`${this.$store.state.islhurl}projectManager/fuzzyQueryBySalesRegion?salesRegion=`;
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				this._post(url, params).then(
					res => {
						this.salesRegionList = res;
					}
				)
			},
			getSurveyStatus() {
				let url = `${this.$store.state.islhurl}keyValue/queryLabelList?keyList=MajorProjectSurveyStatus`;
				const _this = this
				this._get(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key];
							});
						}
					}
				)
			},
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			handleSearch() {
				const values = this.searchForm;
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					...this.searchForm,
					marketSurveyCompletionTimeStart:  values.marketSurveyCompletionTime ? moment(values.marketSurveyCompletionTime[0]).format('YYYY-MM-DD') + ' 00:00:00' : '',
					marketSurveyCompletionTimeEnd:  values.marketSurveyCompletionTime ? moment(values.marketSurveyCompletionTime[1]).format('YYYY-MM-DD') + ' 00:00:00' : '',
					customerSurveyCompletionTimeStart:  values.customerSurveyCompletionTime ? moment(values.customerSurveyCompletionTime[0]).format('YYYY-MM-DD') + ' 00:00:00' : '',
					customerSurveyCompletionTimeEnd:  values.customerSurveyCompletionTime ? moment(values.customerSurveyCompletionTime[1]).format('YYYY-MM-DD') + ' 00:00:00' : '',
				}
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}majorProject/getListByPage/${this.pageSize}/${this.currentPage}`
				this._post(url,params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
						this.tableData = res.data;
						this.totalCount = res.totalNums;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			handleReset() {
				this.searchForm = {};
			},
			handleExport() {
				this.exportLoading = true;
				const date = new Date();
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const values = this.searchForm;
				this.$axios({
					url: `${this.$store.state.islhurl}majorProject/exportData`,
					method: 'post',
					data: {
						...this.searchForm,
						marketSurveyCompletionTimeStart:  values.marketSurveyCompletionTime ? moment(values.marketSurveyCompletionTime[0]).format('YYYY-MM-DD') + ' 00:00:00' : '',
						marketSurveyCompletionTimeEnd:  values.marketSurveyCompletionTime ? moment(values.marketSurveyCompletionTime[1]).format('YYYY-MM-DD') + ' 00:00:00' : '',
						customerSurveyCompletionTimeStart:  values.customerSurveyCompletionTime ? moment(values.customerSurveyCompletionTime[0]).format('YYYY-MM-DD') + ' 00:00:00' : '',
						customerSurveyCompletionTimeEnd:  values.customerSurveyCompletionTime ? moment(values.customerSurveyCompletionTime[1]).format('YYYY-MM-DD') + ' 00:00:00' : '',
						islhToken : sessionStorage.getItem('islhtoken'),
					},
					responseType: "blob"
				}).then(response=>{
					this.exportLoading = false;
					const blob = new Blob([response.data])
					const aEle = document.createElement('a');     // 创建a标签
					const href = window.URL.createObjectURL(blob);       // 创建下载的链接
					aEle.href = href;
					aEle.download = 'Major Project_'+ year + month + day +'.xlsx';  // 下载后文件名
					document.body.appendChild(aEle);
					aEle.click();     // 点击下载 
					document.body.removeChild(aEle); // 下载完成移除元素
					window.URL.revokeObjectURL(href) // 释放掉blob对象
				})
			},
			openDetailFromRoute() {
				const detailStr = sessionStorage.getItem('majorProjectDetail');
				if (detailStr) {
					const detail = JSON.parse(detailStr);
					this.detailShow = true;
					this.detailId = Number(detail.detailId);
					this.detailStatus = detail.detailStatus || '';
					this.companyOrRepresentative = detail.companyOrRepresentative || '';
					this.fromOtherPage = true;
					this.sourceTab = sessionStorage.getItem('majorProjectSourceTab') || '';
					sessionStorage.removeItem('majorProjectDetail');
					sessionStorage.removeItem('majorProjectSourceTab');
				}
			},
			openDetail(record) {
				this.detailShow = true;
				this.fromOtherPage = false;
				this.detailId = record.id;
				this.detailStatus = record.projectStatusDesc;
				this.companyOrRepresentative = record.majorProjectLevel === 4 ? '2' : '1';
        // let params = {
				// 	id: record.id,
				// 	page: 'majorProject'
				// }
				// this.$router.push({ name:'projectApplication', params });
			},
			closeDetail() {
				if (this.fromOtherPage) {
					// 从其他页面跳转过来的，先切回来源页签，再关闭majorProject页签
					if (this.sourceTab && this.$store.state.tagList.includes(this.sourceTab)) {
						this.$store.commit('tabSwitch', this.sourceTab);
					}
					this.$store.commit('tabClose', 'majorProject');
				} else {
					// 本页面打开的详情，只关闭详情回到列表
					this.detailShow = false;
					this.detailId = '';
					this.detailStatus = '';
					this.companyOrRepresentative = '';
				}
				this.fromOtherPage = false;
				this.sourceTab = '';
			},
			changeMoreSearch() {
				this.showMoreSearch = !this.showMoreSearch;
			},
			validateReason(rule, value, callback) {
				if (value === '') {
					callback(new Error('Please input'));
				} else if (value !== 'I acknowledge') {
					callback(new Error('Input is incorrect'));
				} else {
					callback();
				}
			},
			openDelete(record) {
				this.deleteVisible = true
				this.deleteForm = record
			},
			closeDelete() {
				this.deleteVisible = false;
				this.$refs.deleteForm.resetFields();
			},
			projectDelete() {
				this.$refs.deleteForm.validate((valid) => {
					if (valid) {
						// let params = {
						// 	islhToken : sessionStorage.getItem('islhtoken'),
						// 	reason: this.deleteForm.reason,
						// 	id: this.deleteForm.id,
						// 	approvalStatus: this.deleteForm.approvalStatus,
						// 	majorProjectId:  this.deleteForm.majorProjectId,
						// }
						this.deleteLoading = true;
						let url =`${this.$store.state.islhurl}majorProject/delete-full/${this.deleteForm.id}`
						this._post(url).then(
							res => {
								if(res.code === 200) {
									this.$Message.success('Successful!');
									this.closeDelete();
									this.currentPage = 1;
									this.handleSearch();
								} else {
									this.$message.error(res.message || 'Failed!');
								}
								this.deleteLoading = false
							}
						)
					} else {
						return false;
					}
				});
			}
		},
  }
</script>
<style lang="less" scoped>
#projectQuery {
	.hiddencard {
		height: 0;
		overflow: hidden;
	}
	/deep/.el-table .cell {
		word-break: break-word;
	}
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 0px;
			padding: 0 15px 0 0;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 0px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	
	/deep/.el-dialog__body {
		padding: 10px 20px;
		.el-form {
			padding: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/projectQuery/index.vue